import React, { useState } from "react";
import ReactModal from "react-modal";

import { color_black, color_grey_light, color_red_active, color_white, color_red_default, color_grey_dark } from "../../constants/colors";
import RadioBoxEmpty from "../controls/check-boxes/RadioBoxEmpty";
import { OnestNormalSmall, OnestBoldSmall, OnestBoldDefault, Link } from "../styled/TextComponents";
import { useWindowDimensions } from "../../utils";

import { Button } from '../controls/Button/Button';
import moment from "moment-timezone";
import { FormCheckBox } from "../forms/authorization/RegisterForm";
import axios from "axios";
import Config from "../../Config";
import { BsX } from "react-icons/bs";
import { useI18n } from "../../i18n/I18nProvider";

const ModalStartSubscription = ({
    isOpen,
    onClose,
    userData,
    currentTarif,
    setPaymentURL,
}) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const [isAgree, setIsAgree] = useState(false);

    const sendFirstRecurrent = () => {
        if (isAgree) {
            localStorage.setItem("tariff", currentTarif);

            let backendAddr = Config.BACKEND_ADDR + "/payments/newRecurrent/" + currentTarif // /api
            axios.get(backendAddr).then(response => {
                if (response.status === 200) {
                    if (response?.data?.PaymentURL) {
                        setPaymentURL(response?.data?.PaymentURL);
                        // открываем попап с формой оплаты
                        window.location.href = response?.data?.PaymentURL;
                    }
                }
            }).catch(err => {
                alert(err.response?.data?.message || err.message)
            })

        }
    }

    const handleCheckChange = (e) => {
        setIsAgree(e.target.checked);
    };
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                content: {
                    backgroundColor: color_white,
                    borderRadius: "16px",
                    width: screenWidth > 420 ? "360px" : `${screenWidth - 120}px`,
                    //height: "365px",
                    height: "min-content",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    padding: "20px",
                    gap: "10px",
                    inset: screenWidth > 460 ? "40px" : `calc(50vw - ${screenWidth - 120 / 2}px)`
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "hidden",
                },
            }}
        >
            <div
                style={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    cursor: "pointer",
                    zIndex: 1000
                }}
                onClick={onClose}
            >
                <BsX
                    style={{
                        fontSize: 30,
                        color: color_grey_dark
                    }}
                />
            </div>
            <h2
                style={{
                    margin: 0,
                    width: screenWidth > 420 ? "280px" : `${screenWidth - 160}px`,
                }}>{t("Подтвердите подписку и начните 7-дневный пробный период")}</h2>
            <OnestBoldSmall>
                {t("Выбранный тариф: ")}{currentTarif === "m" ? t("Месячный") : t("Годовой")} {t("план")}
            </OnestBoldSmall>
            <div style={{marginTop: 10}}>
            <OnestNormalSmall>
                {t("Сейчас — 0 ₽")}
            </OnestNormalSmall>
            <OnestNormalSmall 
                style={{
                    marginTop: 0,
                }}>
                {t("С ")}{moment().add(7, 'days').format("D MMMM")} {t("будет списано ")}{currentTarif === "m" ? "1 500" : "12 000"} ₽, {t("если вы не отмените подписку")}
            </OnestNormalSmall>
            </div>
            <div style={{
                marginTop: 10,
                display: "flex",
                flexDirection: "row",
                width: "100%",
                gap: 10,
                justifyContent: "flex-end",
            }}>

                <FormCheckBox name={"acceptForRules"} value={isAgree} onChange={handleCheckChange} />
                <OnestNormalSmall style={{ textDecoration: "none" }}>
                    {t("Я соглашаюсь на автосписание, принимаю условия")}
                    <Link href={"/offer.html"} style={{ textDecoration: "none" }}> {t("оферты,")}</Link>
                    <Link href={"/privacy-policy.html"} style={{ textDecoration: "none" }}> {t("политики конфиденциальности")} </Link> {t("и даю")}
                    <Link href={"/personal-data-agreement.html"} style={{ textDecoration: "none" }}> {t("согласие на обработку персональных данных")}</Link>
                </OnestNormalSmall>
            </div>
            <Button
                color={color_white}
                backgroundColor={isAgree ? color_red_default : color_grey_light}
                height="40px"
                //width={screenWidth > 420 ? "320px" : `${screenWidth - 120}px`}
                width="100%"
                onClick={sendFirstRecurrent}
                style={{ 
                    borderColor: isAgree ? color_red_default : color_grey_light ,
                    marginTop: 10,
                    }}
                disabled={!isAgree || !currentTarif}
                
            >
                {t("Подтвердить")}
            </Button>
        </ReactModal>
    );
};

export default ModalStartSubscription;